/**
 * Capitalizes the first letter of a given string.
 * @param {string} str - The string to be capitalized.
 * @returns {string} - The capitalized string.
 */
const capitalize = (str: string): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export default capitalize;
